import { ProjectVariableType } from '@portal-core/project-files/variables/enums/project-variable-type.enum';
import { ProjectVariableDefinition } from '@portal-core/project-files/variables/models/project-variable-definition.model';
import { Node } from 'prosemirror-model';

export class XmlProjectVariableDefinition implements ProjectVariableDefinition {
  private _setName: string;
  private _definitionOrder: number;
  private _node: Element;

  constructor(set: string, node: Element) {
    this._node = node;
    this._setName = set;
    this._definitionOrder = 0;
  }

  public static FormatLongVariable(set: string, name: string): string {
    return `${set}.${name}`;
  }

  public static FormatTextVariable(variableLongName: string): string {
    return `[%=${variableLongName}%]`;
  }

  public get Node() {
    return this._node;
  }

  public get SetName() {
    return this._setName;
  }

  public set SetName(value) {
    this._setName = value;
  }

  public get Definition() {
    return this._node.textContent ?? '';
  }

  public set Definition(value) {
    if (this._node.textContent != value) {
      this._node.textContent = value;
      this._node.removeAttribute('EvaluatedDefinition');
    }
  }

  public get Comment() {
    return this._node.getAttribute('Comment') ?? '';
  }

  public set Comment(value) {
    this._node.setAttribute('Comment', value);
  }

  public get LongName() {
    return XmlProjectVariableDefinition.FormatLongVariable(this._setName, this.Name);
  }

  public get Id() {
    return this.LongName;
  }

  public get Selectable() {
    return this.DefinitionOrder == 0;
  }

  public get Name() {
    return this._node.getAttribute('Name') ?? '';
  }

  public set Name(value) {
    this._node.setAttribute('Name', value);
  }

  public get Type(): ProjectVariableType {
    var val = this._node.getAttribute('Type');
    var type: ProjectVariableType = ProjectVariableType[val];
    if (type)
      return type;
    return ProjectVariableType.Normal;
  }

  public set Type(value: ProjectVariableType) {
    if (value === ProjectVariableType.Normal)
      this._node.removeAttribute('Type');
    else
      this._node.setAttribute('Type', ProjectVariableType[value]);
  }

  public get LastUpdated() {
    return this._node.getAttribute('LastUpdated') ?? '';
  }

  public set LastUpdated(value) {
    this._node.setAttribute('LastUpdated', value);
  }

  public get DefinitionOrder() {
    return this._definitionOrder;
  }

  public set DefinitionOrder(value) {
    this._definitionOrder = value;
  }
}

export class ProjectVariableDefinitionModel implements ProjectVariableDefinition {

  public SetName: string;
  public Name: string;

  public Definition: string;
  public Comment: string;
  public Type: ProjectVariableType;
  public LastUpdated: string;

  public DefinitionOrder: number;

  public get LongName() {
    return XmlProjectVariableDefinition.FormatLongVariable(this.SetName, this.Name);
  }

  public get Id() {
    return this.LongName;
  }

  public get Selectable() {
    return this.DefinitionOrder == 0;
  }

  public NodeId: string;
}

export class ProjectVariableDefinitionChangeModel {
  public Node: Node;
  public NodeId: string;
  public VariableName: string;
  public DefinitionNewValue?: string;
  public CommentNewValue?: string;
}
